<!--发布课程管理-->
<template>

  <div >
    <el-form  ref="registerRef"  :model="createParam" :rules="rules" label-width="150px">
      <el-form-item  label="子类型名称:"  prop="name">
        <el-input style="width: 300px" v-model="createParam.name" placeholder="输入名称"></el-input>
      </el-form-item>
      <el-form-item  label="版本:"  prop="optionsLessonValue">
        <el-select v-model="createParam.optionsLessonValue" placeholder="请选择">
          <el-option
            v-for="item in storeLessons"
            :key="item.id"
            :label="item.type"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item  label="比例:"  prop="ratio">
        <el-input-number v-model="createParam.ratio"></el-input-number>
      </el-form-item>
     
    </el-form>
  </div>
</template>

<style>

</style>

<script>


  import globaldata from "../../../utils/globaldata";
  import enumsUtil, {ECardUseType} from "../../../utils/enumsUtil";

  export default {
    name: 'NewStoreLessonCardInfo',
    props: {
      isExp : Number, //是否是体验卡
      storeLessons:Array,
    },
    data() {
      return {
        createParam :{
        },
        rules:{
          name:[{required:true,message:"请输入子类型名称",trigger:"blur"}],
          optionsLessonValue:[{required:true,message:"请选择业务类型",trigger:"blur"}],
          ratio:[{required:true,message:"请输入比例",trigger:"blur"}],
        },
        cardUseTypeList:ECardUseType(),
      }
    },
    created(){
      this.initData();

    },

    mounted() {

    },
    methods: {
      initData(){
        this.createParam ={
          name: '',
          storeLessonId:"",
          ratio:1,
          optionsLessonValue:"",
        };

      },
      getstoreLesson(lessonTemplateId){
        for (let i = 0;i<this.storeLessons.length;++i){
          if (this.storeLessons[i].id == lessonTemplateId) {
            return this.storeLessons[i];
          }
        }
      },
      getCardInfo(callBack ){

        this.$refs['registerRef'].validate((valid) => {

          if (valid) {
            let storeLessonId = this.getstoreLesson(this.createParam.optionsLessonValue).storeLessonId;

            let info = {
              storeFrontId:globaldata.getAdminStore().storeFrontId,
              name: this.createParam.name,
              storeLessonCardTemplateId:this.createParam.optionsLessonValue,
              ratio:this.createParam.ratio,
            }
            if (callBack){
              callBack(info);
            }
            return info;
          } else {
            if (callBack){
              callBack(false);
            }
            return false
          }
        });
      },

    }
  }
</script>






// WEBPACK FOOTER //
// src/views/store-lesson-card-sub-type/components/NewStoreLessonCardInfo.vue